/**
 * in this module there are:
 *   - the geolocation function
 *   - the search function and the creation of the result list
 */
import {fromLonLat} from 'ol/proj'
import functions from './functions'
/**
 *
 *  to work need some parameter
 * view = the map view
 * fixed = the fixed settings to check the bounds property
 *  - we check this property to check the boundaries for the geolocation
 * overlay = the overlay to hide the popup
 */
 var pageconfig = JSON.parse($('#pageconfig').val())

let lang = $('#dropdownLangButton').attr('data-code')
if (lang === '' || lang === null || typeof lang === 'undefined') {lang = 'en'}

const search = (view, overlay) => {
  /**
   * geolocation
   * run the function when you click on the button
   */

  const mapView = view

  /**
   * populate the hide input for the RestFULL API
   */

  if ($('#ukgaz').length !== 0) {
    $('#ukgaz').val(pageconfig.bounds)
    $('#ukgaz').attr('data-lacode',pageconfig.lacode)
  }

  $('#locposbutton').on('click', () => {
    getLocation()
  })

  /**
   * check if the browser support geolocation
   * display the correct error based on which language is selected
   */

  const getLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(showPosition, showError)
    }
    else {
      if (window.location.href.indexOf('?lang=cy') > -1) {
        $('.locError').text('Ni chefnogir canfod lleoliad gan y porwr hwn.')
      }
      else {
        $('.locError').text('Geolocation is not supported by this browser.')
      }
      $('#locpopup').modal('show')
    }
  }

  /**
   * if the browser support geolocation
   * move the map accordingly
   * or display an error if outside of the boundaries
   * based on which language is selected
   */

  const showPosition = (position) => {
    // get the extent from fixed.json and create the array
    let getExt = pageconfig.bounds.split(',')
    let ext = [parseInt(getExt[0]), parseInt(getExt[1]), parseInt(getExt[2]), parseInt(getExt[3])]

    /**
     * convert the coordinates from longitude/latitude into the x/y format EPSG:27700
     * store it in an object to use it later in the moveMap function
     */

    let coordToConvert = fromLonLat([position.coords.longitude, position.coords.latitude], 'EPSG:27700')
    let convertedCoord = {
      easting: parseFloat(coordToConvert[0]),
      northing: parseFloat(coordToConvert[1])
    }

    if (convertedCoord.easting >= ext[0] && convertedCoord.easting <= ext[2] && convertedCoord.northing >= ext[1] && convertedCoord.northing <= ext[3]) {
      const zoomTo = mapView.getView().getResolutions().length
      moveMap(mapView, zoomTo, convertedCoord)
    }
    else {
      if (window.location.href.indexOf('?lang=cy') > -1) {
        $('.locError').text('Mae eich lleoliad y tu allan i\'r ardal sydd ar gael.')
      }
      else {
        $('.locError').text('Your position is outside the available area.')
      }
      $('#locpopup').modal('show')
    }
  }

  /**
   * callback to display why the geolocations is unavailable
   * based on which language is selected
   */

  const showError = (error) => {
    switch (error.code) {
      case error.PERMISSION_DENIED:
        if (window.location.href.indexOf('?lang=cy') > -1) {
          $('.locError').text('Gwrthodwyd cais y defnyddiwr i Ganfod lleoliad.')
        }
        else {
          $('.locError').text('User denied the request for Geolocation.')
        }
        $('#locpopup').modal('show')
        break

      case error.POSITION_UNAVAILABLE:
        if (window.location.href.indexOf('?lang=cy') > -1) {
          $('.locError').text('Nid yw\'r wybodaeth am y lleoliad ar gael.')
        }
        else {
          $('.locError').text('Location information is unavailable.')
        }
        $('#locpopup').modal('show')
        break

      case error.TIMEOUT:
        if (window.location.href.indexOf('?lang=cy') > -1) {
          $('.locError').text('Daeth cyfnod y cais i gael lleoliad y defnyddiwr i ben.')
        }
        else {
          $('.locError').text('The request to get user location timed out.')
        }
        $('#locpopup').modal('show')
        break

      case error.UNKNOWN_ERROR:
        if (window.location.href.indexOf('?lang=cy') > -1) {
          $('.locError').text('Digwyddodd gwall anhysbys.')
        }
        else {
          $('.locError').text('An unknown error occurred.')
        }
        $('#locpopup').modal('show')
        break

      default:
        if (window.location.href.indexOf('?lang=cy') > -1) {
          $('.locError').text('lleoliad yn gywir')
        }
        else {
          $('.locError').text('position correct')
        }
    }
  }

  /**
   * search behaviour
   */

  /**
   * when you click on the X in the search input:
   *  - hide the result
   *  - reset the input value
   *  - stop any propagation or default behaviour
   */

  $('#searchClose').on('click', (e) => {
    $('#searchcont').hide()
    $('#find').val('')
    e.stopPropagation()
    e.preventDefault()
  })

  /**
   * when you press the ENTER key in the search input:
   *  - execute the find function emulating a click on the search button
   *  - hide the popup in the map
   */

  $('#find').keypress((e) => {
    if (e.which === 13 && $('#find').val() !== '') {
      $('#findbutton').click()
    }
  })

  /**
   * find function based on the hide $('#ukgaz') input:
   *  - ask for the api gazetteer file
   *  - ask for the RestFULL API
   *  - create the address list
   *  - attach a event listener on each address
   */

  $('#findbutton').click(() => {
    // hide the popup
    overlay.setPosition(undefined)

    // prevent execution of the function if the input is empty
    if ($('#find').val() !== '') {
      /**
       * show the loading bar
       * disable the button to preven multiple instances
       */

      $('.loading').show()
      $('#findbutton').prop('disabled', true)

      /**
       * RestFULL API case
       */

      if ($('#ukgaz').length !== 0) {
        // remove previous results from the div
        $('#search_results').empty()

        const findthis = $('#find').val()
        const ext = $('#ukgaz').val()
        const lacodes = $('#ukgaz').attr('data-lacode')
        let type = 'opendata';
        let dataString = `findthis=${findthis}&bbox=${ext}&limit=100`
        if (lacodes !== '' || lacodes !== null || typeof lacodes !== 'undefined') {
            dataString = `findthis=${findthis}&lacode=${lacodes}&limit=100`
        }


        if (pageconfig.gaz) {
            type = 'addressbasesearch';
            dataString = `findaddress=${findthis}&bbox=${ext}&lang=${lang}&limit=100`
            if (lacodes !== '' || lacodes !== null || typeof lacodes !== 'undefined') {
                dataString = `findaddress=${findthis}&lacode=${lacodes}&lang=${lang}&limit=100`
            }
        }

        dataString += `&type=` + type

        // AJAX Code To Submit Form.
        $.ajax({
          type: 'POST',
          dataType: 'json',
          url: '/find-address',
          data: dataString,
          beforeSend: function beforeSend(xhr) {
          xhr.setRequestHeader('X-CSRF-TOKEN', $('meta[name="csrf-token"]').attr('content'))
          }
        })
          .done((data) => {
            /**
             * create the result list
             */

            apiresults(mapView, data)
          })
          /**
           * show the reason why doesn't work on fail
           */

          .fail((jqxhr, textStatus, error) => {
            let err = `${textStatus} , ${error}`
            alert(`getAddress Request Failed: ${err}`)
          })
          .always(() => {
            /**
             * hide the loading bar
             * reenable the search button
             */

            $('.loading').hide()
            $('#findbutton').prop('disabled', false)
          })
      }
    }

    /**
     * end $('#findbutton').click(() => {
     * end const search = (view, fixed, overlay) =>
     */
  })
}

/**
 * move the map to the correct location
 * we initialize the function with parameters in orders to be indipendent
 */

const moveMap = (view, zoomlv, coord) => {
  const zoom = view.getView().getResolutions()
  //if (zoomlv > view.getView().getResolutions().length) {
    zoomlv = view.getView().getResolutions().length - 1
  //}

  view.getView().setResolution(zoom[parseInt(zoomlv) - 1])
  view.getView().centerOn([parseFloat(coord.easting), parseFloat(coord.northing)], view.getSize(), [($(window).innerWidth() / 2), ($(window).innerHeight() / 2)])
  view.updateSize()
}

/**
 * create the result table
 *  - we pass the data for create the address list
 *  - we pass the map view to pass it in the moveMap function
 */

const results = (view, data) => {
  /**
   * create a list of each returned element
   */

  $.each(data, function () {
    const place = this

    $('<li>')
      .hide()
      .append($('<a />', {
        text: place.full_address,
        tabindex: '0'
      }))
      .addClass('findlist')
      .appendTo('#search_results').click(() => {
        /**
         * add the event listener to each element
         * center the map on an element click
         */

        moveMap(view, place.zoomto, place)

        // hide the menu if is a mobile
        if (functions.mobileTabletView()) {
          $('#dropdownToolsMobile').trigger('click')
        }
      })
      // show the list
      .show()
  })

  /**
   * display correct message depending on the result
   */

  /**
   * 0 results or undefined in case of some errors
   * display an error in the list
   */

  if (data.length === 0 || data.length === undefined) {
    $('#search_results').append($('<h5 />', {text: 'Address not found.'}))
    $('#searchcont').show()
  }
  /**
   * 1 result
   * center the map on it
   * show the list with the only result
   */

  else if (data.length === 1) {
    moveMap(view, data[0].zoomto, data[0])

    $('#searchcont').show()

    // hide the menu if is a mobile device
    if (functions.mobileTabletView()) {
      $('#dropdownToolsMobile').trigger('click')
    }
  }
  /**
   * 100 results
   * append the 100 limit result alert
   * show the list with the results
   */

  else if (data.length === 100) {
    $('#search_results').prepend($('<h5 />', {text: 'Please refine your search or select from the list below. Search has returned the first 100 addresses.'}))
    $('#searchcont').show()
  }
  /**
   * > 1 < 100 results
   * show the list with the results
   */

  else {
    $('#searchcont').show()
  }
}

/**
 * create the api result table
 *  - we pass the data for create the address list
 *  - we pass the map view to pass it in the moveMap function
 */

const apiresults = (view, data) => {
  /**
   * create a list of each returned element
   */

  $.each(data.addresses, function () {
    const place = this

    $('<li>')
      .hide()
      .append($('<a />', {
        text: place.full_address
      }))
      .addClass('findlist')
      .appendTo('#search_results').click(() => {
        /**
         * add the event listener to each element
         * center the map on an element click
         */

        moveMap(view, place.zoomto, place)

        // hide the menu if is a mobile
        if (functions.mobileTabletView()) {
          $('#dropdownToolsMobile').trigger('click')
        }
      })
      // show the list
      .show()
  })

  /**
   * display correct message depending on the result
   */

  /**
   * 0 results or undefined in case of some errors
   * display an error in the list
   */

  if (data.error) {
    $('#search_results').append($('<h5 />', {
      text: data.error.reason
    }))
    $('#searchcont').show()
  }
  /**
   * 1 result
   * center the map on it
   * show the list with the only result
   */
  else if (data.addresses.length === 1) {
    moveMap(view, data.addresses[0].zoomto, data.addresses[0])

    $('#searchcont').show()

    // hide the menu if is a mobile device
    if (functions.mobileTabletView()) {
      $('#dropdownToolsMobile').trigger('click')
    }
  }
  /**
   * 100 results
   * append the 100 limit result alert
   * show the list with the results
   */
  else if (data.addresses.length === 100) {
    $('#search_results').prepend($('<h5 />', {
      text: 'Please refine your search or select from the list below. Search has returned the first 100 addresses.'
    }))
    $('#searchcont').show()
  }
  /**
   * > 1 < 100 results
   * show the list with the results
   */
  else {
    $('#searchcont').show()
  }
}

/**
 * EXPORT
 */

export default {
  search
}
